import { render } from "./SurveyQuestionRadio.vue?vue&type=template&id=dc9b8ff4&scoped=true"
import script from "./SurveyQuestionRadio.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionRadio.vue?vue&type=script&lang=js"

import "./SurveyQuestionRadio.vue?vue&type=style&index=0&id=dc9b8ff4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dc9b8ff4"

export default script